/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetAlliancesAllianceIdOk
 */
export interface GetAlliancesAllianceIdOk {
    /**
     * ID of the corporation that created the alliance
     * @type {number}
     * @memberof GetAlliancesAllianceIdOk
     */
    creatorCorporationId: number;
    /**
     * ID of the character that created the alliance
     * @type {number}
     * @memberof GetAlliancesAllianceIdOk
     */
    creatorId: number;
    /**
     * date_founded string
     * @type {Date}
     * @memberof GetAlliancesAllianceIdOk
     */
    dateFounded: Date;
    /**
     * the executor corporation ID, if this alliance is not closed
     * @type {number}
     * @memberof GetAlliancesAllianceIdOk
     */
    executorCorporationId?: number;
    /**
     * Faction ID this alliance is fighting for, if this alliance is enlisted in factional warfare
     * @type {number}
     * @memberof GetAlliancesAllianceIdOk
     */
    factionId?: number;
    /**
     * the full name of the alliance
     * @type {string}
     * @memberof GetAlliancesAllianceIdOk
     */
    name: string;
    /**
     * the short name of the alliance
     * @type {string}
     * @memberof GetAlliancesAllianceIdOk
     */
    ticker: string;
}

/**
 * Check if a given object implements the GetAlliancesAllianceIdOk interface.
 */
export function instanceOfGetAlliancesAllianceIdOk(value: object): value is GetAlliancesAllianceIdOk {
    if (!('creatorCorporationId' in value) || value['creatorCorporationId'] === undefined) return false;
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('dateFounded' in value) || value['dateFounded'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ticker' in value) || value['ticker'] === undefined) return false;
    return true;
}

export function GetAlliancesAllianceIdOkFromJSON(json: any): GetAlliancesAllianceIdOk {
    return GetAlliancesAllianceIdOkFromJSONTyped(json, false);
}

export function GetAlliancesAllianceIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAlliancesAllianceIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorCorporationId': json['creator_corporation_id'],
        'creatorId': json['creator_id'],
        'dateFounded': (new Date(json['date_founded'])),
        'executorCorporationId': json['executor_corporation_id'] == null ? undefined : json['executor_corporation_id'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
        'name': json['name'],
        'ticker': json['ticker'],
    };
}

export function GetAlliancesAllianceIdOkToJSON(json: any): GetAlliancesAllianceIdOk {
    return GetAlliancesAllianceIdOkToJSONTyped(json, false);
}

export function GetAlliancesAllianceIdOkToJSONTyped(value?: GetAlliancesAllianceIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creator_corporation_id': value['creatorCorporationId'],
        'creator_id': value['creatorId'],
        'date_founded': ((value['dateFounded']).toISOString()),
        'executor_corporation_id': value['executorCorporationId'],
        'faction_id': value['factionId'],
        'name': value['name'],
        'ticker': value['ticker'],
    };
}

